import { useEffect } from 'react'
import { useActivePaymentProfile } from 'dashboard-experience/shared/hooks'
import { useIsOneStone } from 'digital-settings/shared/hooks'
import { useGetPaymentProfileId } from 'vendas-core/shared/hooks'

export function useWebhookPaymentProfileId() {
  const isOneStone = useIsOneStone()
  const { activeProfileId, setActiveProfile } = useActivePaymentProfile()
  const { paymentProfileId: defaultPaymentProfileId } = useGetPaymentProfileId()

  useEffect(() => {
    if (isOneStone && !activeProfileId && defaultPaymentProfileId) setActiveProfile(defaultPaymentProfileId)
  }, [isOneStone, activeProfileId, defaultPaymentProfileId, setActiveProfile])

  return { paymentProfileId: activeProfileId || defaultPaymentProfileId }
}
